/**-----------------------------------------------*/
/* 会员
/* -----------------------------------------------*/
import Layout from '../view/member/layout.vue'
import Layout2 from '../view/member/layout2.vue'
import Layout3 from '../view/member/layout3.vue'
import Record from '../view/member/record.vue'
import Wallet from '../view/member/wallet.vue'
import Deposit from '@/view/member/deposit.vue'
import Transfer from '@/view/member/transfer.vue'
import Bank from '@/view/member/bank.vue'
import Withdrawal from '@/view/member/withdrawal.vue'
import Share from '@/view/member/share.vue'
import Help from '@/view/member/help.vue'
import Message from '@/view/member/message.vue'
import Adv from '@/view/member/adv.vue'
import Apply from '@/view/member/apply.vue'
import Setting from '@/view/member/setting.vue'
import Test from '@/view/member/test.vue'
import Dashboard from '@/view/member/dashboard.vue'
import Service from '@/view/member/service.vue'
import Invest from '@/view/member/invest.vue'
import AdvBuy from '@/view/member/adv_buy.vue'
import Income from '@/view/member/income.vue'


const Router = [
  {
    path: '/member',
    name: 'member',
    meta: { isLogin: false, type: 1 },
    component: Layout,
    children: [
      {
        path: '/wallet',
        name: 'wallet',
        meta: { name: 'wallet' },
        component: Wallet
      },
      {
        path: '/record',
        name: 'record',
        meta: { name: 'record' },
        component: Record
      }
    ]
  },
  {
    path: '/member1',
    name: 'member1',
    meta: { isLogin: false, type: 1 },
    component: Layout2,
    children: [
      {
        path: '/deposit',
        name: 'deposit',
        meta: { isLogin: false, type: 1 },
        component: Deposit
      },
      {
        path: '/transfer',
        name: 'transfer',
        meta: { isLogin: false, type: 1 },
        component: Transfer
      },
      {
        path: '/bank',
        name: 'bank',
        meta: { isLogin: false, type: 1 },
        component: Bank
      },
      {
        path: '/withdraw',
        name: 'withdraw',
        meta: { isLogin: false, type: 1 },
        component: Withdrawal
      }
    ]
  },
  {
    path: '/member2',
    name: 'member2',
    meta: { isLogin: false, type: 1 },
    component: Layout3,
    children: [
      {
        path: '/share',
        name: 'share',
        meta: { isLogin: false, type: 1 },
        component: Share
      },
      {
        path: '/help',
        name: 'help',
        meta: { isLogin: false, type: 1 },
        component: Help
      },
      {
        path: '/message',
        name: 'message',
        meta: { isLogin: false, type: 1 },
        component: Message
      },
      {
        path: '/adv',
        name: 'adv',
        meta: { isLogin: false, type: 1 },
        component: Adv
      },
      {
        path: '/adv/buy',
        name: 'adv_buy',
        meta: { isLogin: false, type: 1 },
        component: AdvBuy
      },
      {
        path: '/invest',
        name: 'invest',
        meta: { isLogin: false, type: 1 },
        component: Invest
      },
      {
        path: '/apply',
        name: 'apply',
        meta: { isLogin: false, type: 1 },
        component: Apply
      },
      {
        path: '/setting',
        name: 'setting',
        meta: { isLogin: false, type: 1 },
        component: Setting
      },
      {
        path: '/dashboard',
        name: 'dashboard',
        meta: { isLogin: false, type: 1 },
        component: Dashboard
      },
        {
        path: '/income',
        name: 'income',
        meta: { isLogin: false, type: 1 },
        component: Income
      },
      {
        path: '/service',
        name: 'service',
        meta: { isLogin: false, type: 1 },
        component: Service
      },
      {
        path: '/test',
        name: 'test',
        meta: { isLogin: false, type: 1 },
        component: Test
      }
    ]
  }
]

export default Router
